/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Playbook56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M8 35c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm36-20a8 8 0 110 16 8 8 0 010-16z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M41 7H15a6 6 0 00-6 6v32a6 6 0 006 6h26a6 6 0 006-6V13a6 6 0 00-6-6zm0 2c2.21 0 4 1.79 4 4v32c0 2.21-1.79 4-4 4H15c-2.21 0-4-1.79-4-4V13c0-2.21 1.79-4 4-4h26z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M40.969 49h-26A4 4 0 0111 45.5a5.98 5.98 0 003.969 1.5h26c1.521 0 2.91-.566 3.968-1.5a3.998 3.998 0 01-3.968 3.5z"
            />
            <rect width={34} height={38} x={11} y={7} fill={vars.white} rx={4} />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M13.824 7.005a3 3 0 00-2.819 2.819L11 10v32a3 3 0 002.824 2.995L14 45V7l-.176.005z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M41 5a6 6 0 016 6v30a6 6 0 01-6 6H15a6 6 0 01-6-6V11a6 6 0 016-6zm0 2H15v38h26c2.21 0 4-1.79 4-4V11c0-2.21-1.79-4-4-4zm-27 .126c-1.725.444-3 2.01-3 3.874v30a4.002 4.002 0 003 3.874z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M37.5 15a.5.5 0 010 1h-15a.5.5 0 010-1h15zm-2 2a.5.5 0 010 1h-11a.5.5 0 010-1h11zm-.88 8.215l.087.078 2 2a1 1 0 01-1.327 1.492l-.087-.078-.293-.292V32a4.999 4.999 0 01-4.783 4.995L30 37h-1c-.057 0-.112-.005-.166-.014a3 3 0 11.001-1.971l.048-.008L29 35h1a3 3 0 002.995-2.824L33 32v-3.586l-.293.293a1 1 0 01-1.327.078l-.087-.078a1 1 0 01-.078-1.327l.078-.087 2-2a1 1 0 011.327-.078zM26 35a1 1 0 100 2 1 1 0 000-2zm-1.387-9.79l.094.083L26 26.585l1.293-1.292.094-.083a1 1 0 011.32 1.497L27.415 28l1.292 1.293a1 1 0 01-1.32 1.497l-.094-.083L26 29.415l-1.293 1.292-.094.083a1 1 0 01-1.32-1.497L24.585 28l-1.292-1.293a1 1 0 011.32-1.497z"
            />
            <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M26 35a1 1 0 110 2 1 1 0 010-2z" />
        </g>
    </AccessibleSVG>
);

export default Playbook56;
